<template>
    <ContentOrLoading style="min-height: 600px">
        <LayoutSports v-if="event" :event="event" :event_id="event_id" :sesion_id="sesion_id"/>
    </ContentOrLoading>
</template>

<script>
import LayoutSports from './layouts/show/Sports';

export default {
    props: ['event_id', 'sesion_id'],
    data() {
        return {
            event: null
        }
    },
    components: {
        LayoutSports,
    },
    created() {
        this.getEvent();
    },
    computed : {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    methods: {
        getEvent() {
            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro
                },
                event_id: this.event_id,
                sesion_id: this.sesion_id
            }
    
            this.$store.dispatch(this.config.getVuexAlias('front.events.show'), params).then(res => {
                this.event = res.data.data;
            }).catch(error => {
                this.$router.push({ name: 'front.eventos.index' });
            });
        },
    }
}
</script>
